module.exports = __webpack_public_path__ + "static/media/antigua-beaches-7.63932a18.jpg";